import React from 'react'

const QuestionIcon16pxSvgWhite = (props) => {
      return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM6.87 7.54125H7.90125C8.07375 7.54125 8.21125 7.4 8.23375 7.22875C8.34625 6.40875 8.90875 5.81125 9.91125 5.81125C10.7688 5.81125 11.5538 6.24 11.5538 7.27125C11.5538 8.065 11.0863 8.43 10.3475 8.985C9.50625 9.59625 8.84 10.31 8.8875 11.4688L8.89125 11.74C8.89256 11.822 8.92606 11.9002 8.98453 11.9577C9.04299 12.0153 9.12173 12.0475 9.20375 12.0475H10.2175C10.3004 12.0475 10.3799 12.0146 10.4385 11.956C10.4971 11.8974 10.53 11.8179 10.53 11.735V11.6038C10.53 10.7063 10.8713 10.445 11.7925 9.74625C12.5538 9.1675 13.3475 8.525 13.3475 7.17625C13.3475 5.2875 11.7525 4.375 10.0063 4.375C8.4225 4.375 6.6875 5.1125 6.56875 7.2325C6.56704 7.27287 6.5736 7.31316 6.58804 7.3509C6.60248 7.38863 6.62448 7.42302 6.65269 7.45194C6.68091 7.48085 6.71474 7.5037 6.75211 7.51906C6.78949 7.53442 6.8296 7.54197 6.87 7.54125ZM9.77625 15.595C10.5387 15.595 11.0625 15.1025 11.0625 14.4362C11.0625 13.7463 10.5375 13.2613 9.77625 13.2613C9.04625 13.2613 8.515 13.7463 8.515 14.4362C8.515 15.1025 9.04625 15.595 9.7775 15.595H9.77625Z"
        fill="#fff"
      />
    </svg>
  );
};

export default QuestionIcon16pxSvgWhite